import {Nullable} from "../../../../types";
import {DeviceHistoryEntry, DeviceHistoryEntryField} from "../deviceHistory";
import {Device, DeviceField} from "../device";

export enum EetsDeviceField {
    ID = "id",
    DKV_CUSTOMER_NUMBER = "dkvCustomerNumber",
    LEO_ID = "leoId",
    LEO_ART = "leoArt",
    OBU_ID = "obuId",
    T4E_ID = "t4eId",
    VIN = "vin",
    LICENSE_PLATE = "licensePlate",
    CANCELED_AT = "canceledAt",
    CANCEL_REASON = "cancelReason",
    LOCKED_AT = "lockedAt",
    UNLOCKED_AT = "unlockedAt",
    LOCK_REASON = "lockReason",
    STATUS = "status",
}

export type EetsDevice = Pick<Device, DeviceField.PL_SENT_ID | DeviceField.PL_SENT_STATUS> & {
    [EetsDeviceField.ID]: number;
    [EetsDeviceField.DKV_CUSTOMER_NUMBER]: number;
    [EetsDeviceField.LEO_ID]: string;
    [EetsDeviceField.LEO_ART]: LeoArticle;
    [EetsDeviceField.OBU_ID]: string;
    [EetsDeviceField.T4E_ID]: string;
    [EetsDeviceField.VIN]: string;
    [EetsDeviceField.LICENSE_PLATE]: string;
    [EetsDeviceField.CANCELED_AT]: Nullable<string>;
    [EetsDeviceField.CANCEL_REASON]: Nullable<CancelReason>;
    [EetsDeviceField.LOCKED_AT]: Nullable<string>;
    [EetsDeviceField.UNLOCKED_AT]: Nullable<string>;
    [EetsDeviceField.LOCK_REASON]: Nullable<LockReason>;
    [EetsDeviceField.STATUS]: EetsDevicStatus;
};

export enum LeoArticleField {
    TYPE = "type",
    DESCRIPTION = "description",
}

export interface LeoArticle {
    [LeoArticleField.TYPE]: string;
    [LeoArticleField.DESCRIPTION]: string;
}

export enum ReasonField {
    CODE = "code",
    DESCRIPTION = "description",
}
export interface CancelReason {
    [ReasonField.CODE]: CancelReasonCode;
    [ReasonField.DESCRIPTION]: string;
}

export interface LockReason {
    [ReasonField.CODE]: LockReasonCode;
    [ReasonField.DESCRIPTION]: string;
}

export enum EetsDevicStatus {
    NEW = "new",
    ACTIVE = "active",
    CANCELED = "canceled",
    LOCKED = "locked",
}

export enum CancelReasonCode {
    RETURNED = "01",
    DECLARATION_OF_DESTRUCTION = "02",
    ERROR_DETECTION = "03",
    CANCELED_BY_AGENCY = "04",
    DEFECT = "05",
    RETURN_DUE_TO_T_LOCK = "06",
    FINDING_A_BLOCKED_LEO = "07",
    RETURN_DUE_TO_BANKRUPTCY = "08",
    MAP_DEFECT_WEB = "09",
    TERMINATION_OF_CONTRACT = "10",
    MAP_NO_LONGER_NEEDED_WEB = "11",
    MAP_DATA_NOT_UP_TO_DATE_WEB = "12",
    MISCELLANEOUS_WEB = "13",
    UNDELIVERABLE = "14",
    LATE_PAYMENT = "15",
    DEACTIVATED = "16",
    T4E_BOX_LOSS = "40",
    T4E_BOX_THEFT_STOLEN = "41",
    T4E_BOX_SEPARATION_SEPARATE = "42",
    T4E_BOX_RETURN_VIA_ARVATO = "47",
    TELEPASS_BOX_LOSS_LOST = "50",
    TELEPASS_THEFT_STOLE = "51",
    EMBOSSING_FAULTY = "98",
    OTHER = "99",
}

export enum LockReasonCode {
    OPEN_BALANCE = "B01",
    LACK_OF_SECURITY = "B02",
    MISSING_CARD_RETURNS = "B03",
    CROSS_BORDERS = "B04",
    NEGATIVE = "B05",
    INDEX_RATING = "B06",
    OTHERS = "B10",
    SALES_PARTNERS_FINAL = "B21",
    TEMPORARY_B_SUSPENSION = "B98",
    AUTOM_INHERITANCE_NEW_KNR = "B99",
    AUTOM_SYSTEM_FROM_CUSTOMER_BLOCK = "D01",
    LOSS = "D02",
    THIEVERY = "D03",
    COUNTERFEIT = "D04",
    DUPLICATE = "D05",
    TRANSFER_TO_THIRD_PARTIES = "D06",
    NTZ_BY_FORMER_DRIVER = "D07",
    UNKNOWN_DUBIOUS = "D08",
}

export interface EetsDeviceHistoryEntry
    extends Pick<
        DeviceHistoryEntry,
        | DeviceHistoryEntryField.DEVICE_ID
        | DeviceHistoryEntryField.TIMESTAMP
        | DeviceHistoryEntryField.INFORMATION
        | DeviceHistoryEntryField.SEVERITY
        | DeviceHistoryEntryField.USER_ID
        | DeviceHistoryEntryField.USER_TAG
        | DeviceHistoryEntryField.JOB_ID
        | DeviceHistoryEntryField.FIRMWARE_VERSION
    > {
    [DeviceHistoryEntryField.TYPE]: EetsDeviceHistoryType;
}

export enum EetsDeviceHistoryType {
    DEV_CREATED = "devCreated",
    DEV_UPDATED = "devUpdated",
    DEV_DEREGISTER = "devDeregister",
    DEV_REGISTERED = "devRegister",
    DEV_CANCEL = "devCancel",
    DEV_SCHEDULE_CANC = "devScheduleCanc",
}
